<template>
  <div class="paging_area">
    <!-- 이전 버튼 -->
    <button class="prev10" :disabled="startPage <= 1"
      :style="{ opacity: startPage <= 1 ? 0.3 : 1, cursor: startPage <= 1 ? 'default' : 'pointer' }"
      @click="changePage(startPage - (startPage % 10) - 1)" type="button" title="이전 10페이지">
      &lt;&lt;
    </button>

    <!-- 처음 버튼 -->
    <button class="prev" :disabled="currentPage <= 1"
      :style="{ opacity: currentPage <= 1 ? 0.3 : 1, cursor: currentPage <= 1 ? 'default' : 'pointer' }"
      @click="changePage(currentPage - 2)" type="button" title="이전 페이지">
      &lt;
    </button>

    <div class="paging_num" v-for="page in pages" :key="page" @click="changePage(page - 1)"
      :class="{ active: page - 1 === activeItem }">
      <div>
        <button type="button" title="페이지이동">
          {{ page }}
        </button>
      </div>
    </div>

    <!-- 마지막 버튼 -->
    <button class="next" :disabled="currentPage >= totalPages"
      :style="{ opacity: currentPage >= totalPages ? 0.3 : 1, cursor: currentPage >= totalPages ? 'default' : 'pointer' }"
      @click="changePage(currentPage)" type="button" title="다음 페이지">
      &gt;
    </button>

    <!-- 다음 버튼 -->
    <button class="next10" :disabled="endPage >= totalPages"
      :style="{ opacity: endPage >= totalPages ? 0.3 : 1, cursor: endPage >= totalPages ? 'default' : 'pointer' }"
      @click="changePage(startPage + 10 - (startPage % 10))" type="button" title="다음 10페이지">
      &gt;&gt;
    </button>
  </div>
</template>

<script>
export default {
  props: {
    totalItems: {
      type: Number,
      required: true
    },
    pageSize: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      default: 1
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalItems / this.pageSize);
    },
    startPage() {
      return Math.floor((this.currentPage - 1) / 10) * 10 + 1;
    },
    endPage() {
      return Math.min(this.startPage + 9, this.totalPages);
    },
    pages() {
      const pages = [];
      for (let i = this.startPage; i <= this.endPage; i++) {
        pages.push(i);
      }
      return pages;
    }
  },
  data() {
    return {
      activeItem: this.currentPage - 1
    };
  },
  methods: {
    changePage(pageIndex) {
      this.activeItem = pageIndex;
      this.$emit('pageChange', pageIndex + 1);
    },
  },
  watch: {
    currentPage(newVal) {
      this.activeItem = newVal - 1;
    }
  }
}
</script>
